import { Injectable, Inject } from '@angular/core';

@Injectable( {
    providedIn: 'root'
} )
export class LogService {
    constructor(
        @Inject( 'ENV' ) private env
    ) { }
    log ( origin, fn, data ) {
        if ( this.env.ENV !== 'live' ) {
            console.log( origin.constructor.name, fn, data );
        }

    }
}
